import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function Hero() {
  const scrollToCheckout = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full max-w-4xl mx-auto px-4 py-12 md:py-16" data-id="element-89" data-mp="9lv0eoeuobus">
      <h1 className="text-2xl md:text-4xl font-bold text-center text-gray-900 leading-snug mb-6 max-w-3xl mx-auto" data-id="element-90" data-mp="4lyxkshw2qgt">
        Reducí errores administrativos y riesgos laborales sin contratar
        consultores ni hacer cursos interminables.
      </h1>

      <div className="flex justify-center mb-8" data-id="element-91" data-mp="xaxfboi3nqll">
        <img src="https://cdn.magicpatterns.com/uploads/2SSafk8gv7SwYJAvEa3WPn/f9667a58-27f9-4045-b1f1-5269360eb44c-removebg-preview.png" alt="Kit Recursos Humanos en Orden" className="max-w-full h-auto w-full md:w-3/4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToCheckout} data-id="element-92" data-mp="sb1e1x0sed9q" />
      </div>

      <p className="text-lg md:text-xl text-center text-gray-700 mb-8 leading-relaxed" data-id="element-93" data-mp="384s6ut3mwt56">
        Creado para quienes hacen RRHH en una PYME sin equipo, sin tiempo y con
        la responsabilidad de que todo salga bien.
      </p>

      <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3 mb-10" data-id="element-94" data-mp="39aurxfl1nqya">
        <span className="inline-flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-200 text-sm font-medium text-gray-800 whitespace-nowrap" data-id="element-95" data-mp="3e961rqbca1gi">
          📄 100% PDF
        </span>
        <span className="inline-flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-200 text-sm font-medium text-gray-800 whitespace-nowrap" data-id="element-96" data-mp="358zr0c70zfl1">
          ⚡️ Entrega Inmediata
        </span>
        <span className="inline-flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-200 text-sm font-medium text-gray-800 whitespace-nowrap" data-id="element-97" data-mp="2vjpzoyk0a0xz">
          📚 10 Módulos + 9 Bonos
        </span>
      </div>

      <div className="flex justify-center" data-id="element-98" data-mp="2lmlcqwic61g4">
        <button onClick={scrollToCheckout} className="bg-gradient-to-r from-emerald-400 to-teal-400 text-white px-10 py-4 rounded-full text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all duration-300" data-id="element-99" data-mp="s3349bcaykwh">
          Quiero mi pack RRHH ahora
        </button>
      </div>
    </section>;
}